import querystring from 'qs';
import $http from '@vue-util/http';
import constants from '../utils/constants';

/**
 * Retrieves pros recommendations.
 *
 * @function
 * @async
 * @param {Object} request - The request object.
 * @param {string} request.zone - The zone to retrieve recommendations for.
 * @param {number} request.timeout - The timeout for the request.
 * @returns {Promise<Object>} - The response data.
 */
const getProsRecommendations = async (request) => {
  const data = querystring.stringify({
    context: request.zone,
    ...request,
  });
  const headerDict = {
    timeout: request.timeout,
    dataType: 'json',
  };
  const url = constants.PATH_RTO_RECOMMENDATIONS;
  return $http.post(url, data, headerDict);
};

export default getProsRecommendations;
